module.exports = [{
      plugin: require('/Users/knewtone/OneDrive/knewtone.com/projects/WorkSpace/customers/g-letitan.media/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/knewtone/OneDrive/knewtone.com/projects/WorkSpace/customers/g-letitan.media/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/knewtone/OneDrive/knewtone.com/projects/WorkSpace/customers/g-letitan.media/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
